export const FETCH_BANK_INFO = 'FETCH_BANK_INFO';
export const FETCH_BANK_INFO_SUCCESS = 'FETCH_BANK_INFO_SUCCESS';
export const FETCH_BANK_INFO_FAILURE = 'FETCH_BANK_INFO_FAILURE';
export const PATCH_BANK_INFO_FAILURE = 'PATCH_BANK_INFO_FAILURE';
export const FETCH_BANK_INFO_FIELD_SUCCESS = 'FETCH_BANK_INFO_FIELD_SUCCESS';
export const PATCH_BANK_INFO = 'PATCH_BANK_INFO';
export const PATCH_BANK_INFO_SUCCESS = 'PATCH_BANK_INFO_SUCCESS';
export const OPEN_BANK_MODAL = 'OPEN_BANK_MODAL';
export const CLOSE_BANK_MODAL = 'CLOSE_BANK_MODAL';

export const fetchBankInfo = () => ({
  type: FETCH_BANK_INFO,
});

export const patchBankInfo = (bankInfoData) => ({
  type: PATCH_BANK_INFO,
  payload: {
    bankInfoData,
  },
});

export const fetchBankInfoSuccess = ({
  is_bank_account_completed: bankAccountCompleted,
  ...bankInfoData
}) => ({
  type: FETCH_BANK_INFO_SUCCESS,
  payload: {
    bankAccountCompleted,
    bankInfoData,
  },
});

export const patchBankInfoSuccess = ({
  is_bank_account_completed: bankAccountCompleted,
  ...bankInfoData
}) => ({
  type: PATCH_BANK_INFO_SUCCESS,
  payload: {
    bankAccountCompleted,
    bankInfoData,
  },
});

export const fetchBankInfoFailure = ({ errorMessage }) => ({
  type: FETCH_BANK_INFO_FAILURE,
  payload: {
    errorMessage,
  },
});
export const patchBankInfoFailure = ({ errorMessage }) => ({
  type: PATCH_BANK_INFO_FAILURE,
  payload: {
    errorMessage,
  },
});

export const fetchBankInfoFieldSuccess = ({ bankNeedColumn }) => ({
  type: FETCH_BANK_INFO_FIELD_SUCCESS,
  payload: {
    bankNeedColumn,
  },
});
export const openBankModal = () => ({
  type: OPEN_BANK_MODAL,
});

export const closeBankModal = () => ({
  type: CLOSE_BANK_MODAL,
});

const INIT_STATE = {
  bankAccountCompleted: true,
  bankModalOpenStatus: false,
  bankInfoFields: [],
  bankInfoData: {},
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_BANK_INFO_SUCCESS:
      return {
        ...state,
        bankAccountCompleted: action.payload.bankAccountCompleted,
        bankInfoData: action.payload.bankInfoData,
      };
    case FETCH_BANK_INFO_FAILURE:
      return {
        ...state,
        errorMessage: action.payload.errorMessage,
      };
    case FETCH_BANK_INFO_FIELD_SUCCESS:
      return {
        ...state,
        bankInfoFields: [...action.payload.bankNeedColumn],
      };
    case PATCH_BANK_INFO_SUCCESS:
      return {
        ...state,
        bankAccountCompleted: action.payload.bankAccountCompleted,
        bankInfoData: action.payload.bankInfoData,
        bankModalOpenStatus: false,
      };
    case OPEN_BANK_MODAL:
      return {
        ...state,
        bankModalOpenStatus: true,
      };
    case CLOSE_BANK_MODAL:
      return {
        ...state,
        bankModalOpenStatus: false,
      };
    default:
      return { ...state };
  }
};
export const getBankAccountCompleted = (state) =>
  state.bank.bankAccountCompleted;
export const getBankInfoFields = (state) => state.bank.bankInfoFields;
export const getBankInfoData = (state) => state.bank.bankInfoData;
export const getBankModalOpenStatus = (state) => state.bank.bankModalOpenStatus;

export default reducer;



// WEBPACK FOOTER //
// ./src/services/redux/bank.js